export const SUPERADMIN = 'support@tawi.com.ph';
export const GA_TRACKING_ID = {
    dev: 'UA-164583377-1',
    prod: 'UA-164625536-1'
}